import axios from 'axios';
import { api } from '../utils/index';
import { v4 as uuidv4 } from 'uuid';

export const FETCH_DASHBOARD_SUCCESS = 'FETCH_DASHBOARD_SUCCESS';
export const FETCH_DASHBOARD_FAILURE = 'FETCH_DASHBOARD_FAILURE';
export const CREATE_DASHBOARD_START = 'CREATE_DASHBOARD_STAR';
export const CREATE_DASHBOARD_SUCCESS = 'CREATE_DASHBOARD_SUCCESS';
export const CREATE_DASHBOARD_FAILURE = 'CREATE_DASHBOARD_FAILURE';
export const UPDATE_DASHBOARD_START = 'UPDATE_DASHBOARD_START';
export const UPDATE_DASHBOARD_SUCCESS = 'UPDATE_DASHBOARD_SUCCESS';
export const UPDATE_DASHBOARD_FAILURE = 'UPDATE_DASHBOARD_FAILURE';
export const DELETE_DASHBOARD_SUCCESS = 'DELETE_DASHBOARD_SUCCESS';
export const DELETE_DASHBOARD_FAILURE = 'DELETE_DASHBOARD_FAILURE';

function fetchDashboardSuccess(payload) {
  return {
    type: FETCH_DASHBOARD_SUCCESS,
    payload
  };
}

function fetchDashboardFailure() {
  return {
    type: FETCH_DASHBOARD_FAILURE
  };
}

function createDashboardStart(payload) {
  return {
    type: CREATE_DASHBOARD_START,
    payload
  };
}

function createDashboardSuccess(payload) {
  return {
    type: CREATE_DASHBOARD_SUCCESS,
    payload
  };
}

function createDashboardFailure() {
  return {
    type: CREATE_DASHBOARD_FAILURE
  };
}

function updateDashboardStart(payload) {
  return {
    type: UPDATE_DASHBOARD_START,
    payload
  };
}

function updateDashboardSuccess(payload) {
  return {
    type: UPDATE_DASHBOARD_SUCCESS,
    payload
  };
}

function updateDashboardFailure() {
  return {
    type: UPDATE_DASHBOARD_FAILURE
  };
}

function deleteDashboardSuccess(payload) {
  return {
    type: DELETE_DASHBOARD_SUCCESS,
    payload
  };
}

function deleteDashboardFailure() {
  return {
    type: DELETE_DASHBOARD_FAILURE
  };
}

const defaultSettings = {
  beneficiaries: {
    metric: 'Report Count',
    segment: 'By Portfolio',
    filter: 'All time',
    year: [],
    beneficiaries: [53, 37, 52, 36, 51, 35],
    switch: 'Any',
    compare: '',
    comparisonyear: 'No Comparison',
    status: 'Active'
  },
  donations: {
    segment: 'Portfolio',
    filter: 'All time',
    year: [],
    donationType: 'All types',
    switch: '',
    comparisonyear: 'None',
    compare: 'No Comparison'
  },
  reportingCompliance: {
    segment: 'Portfolio',
    filter: 'All time',
    year: [],
    invitation_ago: 'No limit',
    comparisonyear: 'No Comparison',
    compare: ''
  },
  dataQuality: {
    segment: 'NPO',
    filter: 'All time',
    year: [],
    comparisonyear: 'No Comparison',
    compare: ''
  },
  impacts: {
    metric: 'Total claim',
    segment: 'Portfolio',
    filter: 'All time',
    year: [],
    indicators: [
      'gain STEM credential',
      'improve academic performance',
      'improve health',
      'become advocates/patrons',
      'gain employment',
      'lbs. of materials recycled',
      'realize other benefit from stewardship program (custom definition)',
    ],
    catalized: true,
    portfolios: [],
    services: [],
    allocation: 'All'
  }
};

const board = {
  name: 'Default',
  description: 'Default Dashboard',
  cards: [
    {
      id: uuidv4(),
      title: 'Impacts',
      settings: defaultSettings.impacts
    },
    {
      id: uuidv4(),
      title: 'Donations',
      settings: defaultSettings.donations
    },
    {
      id: uuidv4(),
      title: 'Reporting Compliance',
      settings: defaultSettings.reportingCompliance
    },
    {
      id: uuidv4(),
      title: 'Data Quality',
      settings: defaultSettings.dataQuality
    },
    {
      id: uuidv4(),
      title: 'Beneficiaries',
      settings: defaultSettings.beneficiaries
    }
  ]
}; 

export function fetchDashboard() {
  return dispatch => {
    return axios
      .get(`${api}v4/dashboard`)
      .then(response => response.data)
      .then(dashboards => {
        if (dashboards.length === 0) {
          dispatch(createDashboard(board));
        }
        return dispatch(fetchDashboardSuccess(dashboards));
      })
      .catch(() => dispatch(fetchDashboardFailure()));
  };
}

export function createDashboard({ name, description, cards }) {
  return dispatch => {
    const form = { name, description, template: { cards } };
    dispatch(createDashboardStart(form));
    return axios
      .post(`${api}v4/dashboard`, form)
      .then(response => response.data)
      .then(event => {
        dispatch(createDashboardSuccess({ event }));
        dispatch(fetchDashboard());
        return event;
      })
      .catch(() => dispatch(createDashboardFailure()));
  };
}

export function updateDashboard({ id, name, description, cards }) {
  return dispatch => {
    const form = { name, description, template: { cards } };
    dispatch(updateDashboardStart({ id, cards }));
    return axios
      .patch(`${api}v4/dashboard/${id}`, form)
      .then(response => response.data)
      .then(event => {
        dispatch(updateDashboardSuccess(event));
        dispatch(fetchDashboard());
        return event;
      })
      .catch(() => dispatch(updateDashboardFailure()));
  };
}

export function defaultDashboard({ id, cards, isDefault }) {
  return dispatch => {
    const form = { template: { cards, isDefault } };
    dispatch(updateDashboardStart({ id, cards }));
    return axios
      .patch(`${api}v4/dashboard/${id}`, form)
      .then(response => response.data)
      .then(event => {
        dispatch(updateDashboardSuccess(event));
        dispatch(fetchDashboard());
        return event;
      })
      .catch(() => dispatch(updateDashboardFailure()));
  };
}

export function deleteDashboard(id) {
  return dispatch => {
    return axios
      .delete(`${api}v4/dashboard/${id}`)
      .then(response => response.data)
      .then(event => {
        dispatch(deleteDashboardSuccess({ id, event }));
        dispatch(fetchDashboard());
        return event;
      })
      .catch(() => dispatch(deleteDashboardFailure()));
  };
}
